$(document).ready(function () {
    $('.account-icon').on('click', function () {
        $('.user-icon').toggleClass('-visible');
    });
});